/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$(document).ready(function(){
   
  let intervalCount = 0;
  
  var myInterval = setInterval(function(){
      $('.ProductItem').each(function(){
          let txt = $(this).find('.ProductItem__Info').find('span.Price--compareAt').text();
          let txtt = txt.substring(3);
          let oldPrice = txtt.split(',').join('');
	      console.log(oldPrice, txt)

          let txt1 = $(this).find('span.Price--highlight').text();            
          let txtt1 = txt1.substring(3);
          let newPrice = txtt1.split(',').join('');
		console.log(newPrice, txt1)
          let discount = parseInt(oldPrice) - parseInt(newPrice);
          let percent = discount / parseInt(oldPrice);

          let percent2 = percent.toFixed(1);
          $(this).find('.discount-percent').html( Math.floor(Math.round(percent * 100)) );
        
      });
    intervalCount +=1;
    
    if(intervalCount > 10){
      clearInterval(myInterval);
    }
    
},500);
})

$(window).on('load', function(){
  	$(".Footer__Social").prepend("<label>&nbsp;&nbsp;&nbsp;&nbsp;FOLLOW US ON</label>");
  	$(".ProductMeta__ShareTitle").html("Follow Us On ");
	$(".ProductItem").each(function(){
        var $this = $(this);
        var str = $this.find('.ProductItem__Wrapper').children('a').attr('href');
      if(str.includes('new-arrivals') == true){
       $this.find('.collection-products').append('<span class="new-arrival-tag">New</span>');
      }
  	});
  
})
